import React from 'react';
import { Link } from 'react-router-dom';
import { FEATURES, COLORS } from '../../data/siteData';
import { Monitor, QrCode, CreditCard, MessageSquare, BarChart3, Shield, ArrowRight } from 'lucide-react';

const iconMap = {
  monitor: Monitor,
  qr: QrCode,
  card: CreditCard,
  sms: MessageSquare,
  chart: BarChart3,
  shield: Shield,
};

const FeaturesSection = ({ onContactClick }) => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: COLORS.dark }}>
            {FEATURES.title}
          </h2>
          <p className="text-lg" style={{ color: COLORS.gray }}>
            {FEATURES.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {FEATURES.items.map((feature, index) => {
            const IconComponent = iconMap[feature.icon] || Monitor;
            return (
              <div 
                key={index}
                className="group flex items-start space-x-4 p-6 rounded-xl bg-gray-50 transition-all duration-300 cursor-pointer hover:shadow-lg"
                style={{ 
                  '--hover-bg': COLORS.yellow,
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = COLORS.yellow;
                  e.currentTarget.querySelector('.feature-title').style.color = COLORS.dark;
                  e.currentTarget.querySelector('.feature-desc').style.color = COLORS.dark;
                  e.currentTarget.querySelector('.feature-icon-wrapper').style.backgroundColor = '#fff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '';
                  e.currentTarget.querySelector('.feature-title').style.color = COLORS.dark;
                  e.currentTarget.querySelector('.feature-desc').style.color = COLORS.gray;
                  e.currentTarget.querySelector('.feature-icon-wrapper').style.backgroundColor = COLORS.yellow + '20';
                }}
              >
                <div 
                  className="feature-icon-wrapper w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-300"
                  style={{ backgroundColor: COLORS.yellow + '20' }}
                >
                  <IconComponent 
                    className="w-6 h-6 transition-colors duration-300" 
                    style={{ color: COLORS.yellow }}
                  />
                </div>
                <div>
                  <h3 
                    className="feature-title text-lg font-semibold mb-1 transition-colors duration-300" 
                    style={{ color: COLORS.dark }}
                  >
                    {feature.title}
                  </h3>
                  <p 
                    className="feature-desc text-sm transition-colors duration-300" 
                    style={{ color: COLORS.gray }}
                  >
                    {feature.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center space-y-4">
          <button
            onClick={onContactClick}
            className="text-base font-medium underline underline-offset-4 hover:opacity-70 transition-opacity"
            style={{ color: COLORS.green }}
          >
            {FEATURES.cta}
          </button>
          
          {/* Internal Link to Solutions Page */}
          <div>
            <Link
              to="/sprendimai-bibliotekoms"
              className="inline-flex items-center gap-2 text-base font-medium transition-colors hover:opacity-80"
              style={{ color: COLORS.green }}
            >
              {FEATURES.seeAllLink}
              <ArrowRight className="w-5 h-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
